// Test IDs for the SSH Keys table component
export const SSH_KEYS_TABLE_TEST_IDS = {
  root: 'ssh-keys-list',
  row: (id: number) => `ssh-key-row-${id}`,
  viewAction: (id: number) => `ssh-key-view-action-${id}`,
  deleteAction: (id: number) => `ssh-key-delete-action-${id}`,
  reAddAction: (id: number) => `ssh-key-readd-action-${id}`,
  removeAction: (id: number) => `ssh-key-remove-action-${id}`,
};
